import React from 'react';
import { array, string, object, bool } from 'prop-types';
import Accordion from '../../atoms/accordion';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import './link-list.m.css';
import { parseSubTitle } from '../../../helpers/utils';
import { isMobile } from 'react-device-detect';
import { getCookieValue, getUserStatus } from '../../../helpers/utils';

const LinkList = ({
  links,
  sectionHeading,
  gridType = 'col',
  styling,
  sectionDivider = 'default',
  accordion = false,
  className,
  isCopyright = false,
  customClass = '',
  threeCol = false,
}) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const formattedPageType =
    pageType === 'story-page' ? 'story' : pageType !== 'home-page' ? 'section-page' : pageType;
  return links ? (
    <Accordion disable={!accordion} className={className} customClass={customClass}>
      <div styleName="list">
        {sectionHeading && <h6 styleName="heading">{sectionHeading}</h6>}
        <div
          styleName={`items ${gridType === 'col' ? `vertical ${customClass}` : 'horizontal'} ${threeCol ? 'three-col' : ''}`}
        >
          {links.map((i, index) => {
            const { text } = parseSubTitle(i?.SubTitle);
            return (
              <React.Fragment key={`${i.Link}-${index}`}>
                <a
                  styleName={`item ${isCopyright ? 'copyright-item' : ''}`}
                  href={i.Link}
                  target={i.Target || '_blank'}
                  rel={i.Rel || 'noopener noreferrer'}
                  style={styling && styling.listItem}
                  onClick={() => {
                    const baseData = {
                      event: 'footer_interaction',
                      cta_text: i?.Title || 'NA',
                      section_name: 'ndtv profit',
                      page_template: formattedPageType,
                      user_id: userData?.userProfile?.userId || 'NA',
                      user_status: getUserStatus(),
                      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
                      language_hit: 'english',
                      Platform: isMobile ? 'mobile' : 'desktop',
                      SiteName: 'www.ndtvprofit.com',
                    };

                    if (typeof window !== 'undefined' && window.dataLayer) {
                      window.dataLayer.push(baseData);
                    } else {
                      console.error('Error: window.dataLayer is not available');
                    }
                  }}
                >
                  {i.Title}
                  {i.Title?.toLowerCase() === 'live tv' && (
                    <div styleName="liveDot">
                      <span styleName="circle" />
                    </div>
                  )}
                  {text && <span styleName="label">{text}</span>}
                </a>
                {sectionDivider === 'dot' && index !== links.length - 1 && <div styleName="dot" />}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </Accordion>
  ) : null;
};

LinkList.propTypes = {
  links: array,
  sectionHeading: string,
  gridType: string,
  sectionDivider: string,
  styling: object,
  accordion: bool,
  className: string,
};

export default LinkList;
